import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Polls a server-side email job until completion. onProgress receives the job doc.
export const pollEmailJob = async (jobId, onProgress) => {
  let consecutiveFailures = 0;
  let lastProcessed = -1;
  let stagnantPolls = 0;
  while (true) {
    await new Promise((r) => setTimeout(r, 2500));
    let job;
    try {
      const res = await axios.get(`${API}/email-jobs/${jobId}`);
      job = res.data;
      consecutiveFailures = 0;
    } catch (e) {
      consecutiveFailures += 1;
      if (consecutiveFailures >= 10) {
        throw new Error('Lost connection while checking email progress. The server is still sending - refresh in a minute to see results.');
      }
      continue;
    }
    if (onProgress) onProgress(job);
    if (job.status === 'completed') return job;
    if (job.processed === lastProcessed) {
      stagnantPolls += 1;
      if (stagnantPolls >= 36) {
        throw new Error('Email sending appears stalled. It is safe to retry - anyone already emailed will be skipped.');
      }
    } else {
      stagnantPolls = 0;
      lastProcessed = job.processed;
    }
  }
};
